import { AbleCommonProps } from "../Types";
import usePaginate, { PageProps } from "./usePaginate";
import "./style.scss";
import NumberButton from "./NumberButton";

export type PaginationStepperProps = { 
    id?: string;
    /** This will be attached to aria-label */
    label?: string;
    customClass?: string;
 } & PageProps & AbleCommonProps;

/**
 * PaginationStepper is a component can be in Table or Individually
 *
 *
 * @version 1.0.0
 */


const PaginationStepper = (props: PaginationStepperProps) => {
    const { onPageChange, developmentUrl, page = 1, id = 'pagination-stepper', customClass = '', ...rest } = props;

    const { nextPage, previousPage, pages, nextPageDisabled, previousPageDisabled } = usePaginate({
        type: 'stepper',
        page,
        onPageChange,
        ...rest
    });

    if (page > pages) {
        console.error("Page number can not be greater than " + pages);
    }

    const pageDetailsId = `${id}--page-details`;

    return <nav aria-label="Pagination" data-testid="pagination" className={customClass}>
        <div className='ted-ui-pagination-stepper'>

            <NumberButton icon="ChevronLeft" onClick={previousPage} aria-disabled={previousPageDisabled} aria-label={"Previous Page"} data-testid="previousButton" developmentUrl={developmentUrl} aria-describedby={pageDetailsId} />

            <div className="ted-ui-stepper-count" id={pageDetailsId}>
                <span className="sr-only">Current page</span>
                <span data-testid="currentPage">{page}</span>
                <span> of </span>
                <span data-testid="totalPages">{pages}</span>
            </div>

            <NumberButton icon="ChevronRight" onClick={nextPage} aria-disabled={nextPageDisabled} aria-label={"Next Page"} data-testid="nextButton" developmentUrl={developmentUrl} aria-describedby={pageDetailsId} />

        </div>
    </nav>
}

export default PaginationStepper;